// Laadt de Google-scripts pas wanneer de gebruiker Google Slides kiest (niet bij
// het openen van de app): Google Identity Services (OAuth-token) en de
// Google Picker (via de gapi-loader). Eén keer per pagina geladen.

export const GIS_SCRIPT_URL = 'https://accounts.google.com/gsi/client';
export const GAPI_SCRIPT_URL = 'https://apis.google.com/js/api.js';

export class GoogleScriptError extends Error {
  constructor(message = 'De Google-onderdelen konden niet worden geladen.') {
    super(message);
    this.name = 'GoogleScriptError';
  }
}

const scriptPromises = new Map<string, Promise<void>>();
let pickerPromise: Promise<void> | null = null;

function loadScript(src: string): Promise<void> {
  const existing = scriptPromises.get(src);
  if (existing) return existing;
  const promise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => {
      script.remove();
      scriptPromises.delete(src); // opnieuw proberen mag (bijv. na een netwerkfout)
      reject(new GoogleScriptError());
    };
    document.head.appendChild(script);
  });
  scriptPromises.set(src, promise);
  return promise;
}

export async function loadGoogleIdentityServices(): Promise<void> {
  await loadScript(GIS_SCRIPT_URL);
  if (!(window as any).google?.accounts?.oauth2) throw new GoogleScriptError();
}

export async function loadGooglePicker(): Promise<void> {
  if (pickerPromise) return pickerPromise;
  pickerPromise = (async () => {
    await loadScript(GAPI_SCRIPT_URL);
    const gapi = (window as any).gapi;
    if (!gapi?.load) throw new GoogleScriptError();
    await new Promise<void>((resolve, reject) => {
      gapi.load('picker', { callback: () => resolve(), onerror: () => reject(new GoogleScriptError()) });
    });
    if (!(window as any).google?.picker) throw new GoogleScriptError();
  })().catch((error) => {
    pickerPromise = null;
    throw error;
  });
  return pickerPromise;
}

/** Alleen voor tests. */
export function resetGoogleScriptCache(): void {
  scriptPromises.clear();
  pickerPromise = null;
}
